<template>
  <div>
    <div class="ts-split sga-page-11 page-11">
      <div
        class="ts-selected-tasks"
        v-if="sgaHiddenTalents.skillsKnowledgeOutsideWork.length >= 1"
        style="display:none"
      >
        <div class="content">
          <div class="top" @click="toggleList()">
            <div class="total"><i class="fas fa-check-circle"></i></div>
            <div class="label">Talents Selected</div>
            <img
              class="dropdown"
              src="~../../../../assets/img/down.svg"
              :class="{ flip: hideList }"
            />
          </div>
          <div class="list" :class="{ open: hideList }">
            <div
              class="item"
              v-for="(item,
              index) in sgaHiddenTalents.skillsKnowledgeOutsideWork"
              :key="`ooi-${index}`"
            >
              <span class="label">{{ item }}</span>
              <img
                class="remove"
                src="~../../../../assets/img/remove.svg"
                @click="userDeselectedSkill(item)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="ts-split--section">
        <h3>Hidden Talents</h3>
        <p>
          <strong
            >To help highlight your hidden talents, select what things you like
            to do around the house, in your community or in your free
            time.</strong
          ><br />
        </p>
        <p class="disclaimer">
          <strong>
            Honest responses will assist us in completing an accurate profile of your skills and hidden talents.
          </strong>
        </p>

        <el-form @submit.native.prevent>
          <label role="text">Hidden Talents</label>
          <el-form-item :required="true">
            <SgaQPage7TalentGroup
              v-for="(group, index) in hiddenTalents"
              :key="index"
              :group="group"
              @test="testAlert"
              @skillSelected="userSelectedSkill"
              :selectedItems="sgaHiddenTalents.skillsKnowledgeOutsideWork"
            >
            </SgaQPage7TalentGroup>
          </el-form-item>
        </el-form>
        <el-alert
          v-if="
            retrieveFieldError(
              modelState,
              'sgaHiddenTalents.skillsKnowledgeOutsideWork'
            )
          "
          :title="
            retrieveFieldError(
              modelState,
              'sgaHiddenTalents.skillsKnowledgeOutsideWork'
            )
          "
          type="error"
        ></el-alert>
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          @click="storeSection()"
        >
          Continue
        </button>
        <a class="back-link" href="/sga/questionnaire/10">
          <i class="fas fa-chevron-left"></i>Back
        </a>
      </div>

      <div
        class="ts-split--panel"
        v-if="sgaHiddenTalents.skillsKnowledgeOutsideWork.length"
      >
        <div class="ts-split--panel_selection ts-off-canvas">
          <span class="h6">Selected Items</span>
          <transition-group name="list" tag="div">
            <div
              class="item"
              v-for="(item,
              index) in sgaHiddenTalents.skillsKnowledgeOutsideWork"
              :key="`ooi-${index}`"
            >
              <i class="ts-icon el-icon-circle-check green"></i>
              <span class="item-label">{{ item }}</span>
              <a class="item-remove" @click="userDeselectedSkill(item)"
                >Remove</a
              >
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page11"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import SgaQPage7TalentGroup from "../../components/SgaQPage7TalentGroup.vue";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    SgaQPage7TalentGroup,
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection
  },
  created() {
    this.$store.dispatch("sga/getsga").then(res => {
      if (this.currentSga.sgaHiddenTalents != null) {
        this.sgaHiddenTalents = this.currentSga.sgaHiddenTalents;
      }
      this.$store.dispatch("onet/hiddenTalents").then(res => {
        this.$store.dispatch("sga/setHiddenTalents", res);
      });
    });

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      showResumeListModal: false,
      isLoading: false,
      modelState: {},
      selectedCount: 0,
      windowWidth: null,
      hideList: false,
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        jobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      selectedSkills: [],
      hideList: false,
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      profile: {},
      profileSettings: []
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    hiddenTalents() {
      return this.$store.state.sga.hiddenTalents;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks
        };
      }
    },
    page3() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3;
        } else {
          return { sgaEducation: this.sgaEducation };
        }
      } else {
        return { sgaEducation: this.sgaEducation };
      }
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4;
        } else {
          return { sgaWorkHistory: this.sgaWorkHistory };
        }
      } else {
        return { sgaWorkHistory: this.sgaWorkHistory };
      }
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5;
        } else {
          return {
            sgaCertifications: this.sgaCertifications,
            selectedCodeDetail: this.selectedCodeDetail
          };
        }
      } else {
        return {
          sgaCertifications: this.sgaCertifications,
          selectedCodeDetail: this.selectedCodeDetail
        };
      }
    },
    page6() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page6) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page6;
        } else {
          return { sgaHiddenExtras: this.sgaHiddenExtras };
        }
      } else {
        return { sgaHiddenExtras: this.sgaHiddenExtras };
      }
    },
    page7() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page7) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page7;
        } else {
          return { sgaKnowledge: this.sgaKnowledge };
        }
      } else {
        return { sgaKnowledge: this.sgaKnowledge };
      }
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies,
      };
    },
    page9() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page9) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page9;
        } else {
          return { sgaMindset: this.sgaMindset };
        }
      } else {
        return { sgaMindset: this.sgaMindset };
      }
    },
    page10() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page10) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page10;
        } else {
          return { sgaSkills: this.sgaSkills };
        }
      } else {
        return { sgaSkills: this.sgaSkills };
      }
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture
      };
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store
        .dispatch("account/getprofiledetails", obj)
        .then(res => {
          this.profile = res;
          this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
          this.closeResumeListModal();

          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        })
        .catch(() => {
          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        });
    },
    storeSection() {
      this.isLoading = true;
      this.currentSga.sgaHiddenTalents = this.sgaHiddenTalents;
      this.currentSga.sgaHiddenTalents.isComplete = true;
      if (this.currentSga.sgaHiddenTalents.id == null) {
        this.$store
          .dispatch("sga/postsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("sga/putsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: this.page5,
          page6: this.page6,
          page7: this.page7,
          page8: this.page8,
          page9: this.page9,
          page10: { sgaHiddenTalents: this.currentSga.sgaHiddenTalents }
        }).finally(res => {
          this.isLoading = false;
        })
      );
      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: this.page5,
          page6: this.page6,
          page7: this.page7,
          page8: this.page8,
          page9: this.page9,
          page10: { sgaHiddenTalents: this.currentSga.sgaHiddenTalents }
        })
      );
    },
    userSelectedSkill(skill) {
      if (!this.sgaHiddenTalents.skillsKnowledgeOutsideWork.includes(skill)) {
        this.sgaHiddenTalents.skillsKnowledgeOutsideWork.push(skill);
        // this.$notify({
        //   title: "Item added",
        //   position: "bottom-right",
        //   type: "success"
        // });
      }
    },
    userDeselectedSkill(skill) {
      this.sgaHiddenTalents.skillsKnowledgeOutsideWork = this.sgaHiddenTalents.skillsKnowledgeOutsideWork.filter(
        v => v !== skill
      );
    },
    toggleList() {
      // this.hideList = !!this.hideList;
      if (this.hideList == false) {
        this.hideList = true;
      } else {
        this.hideList = false;
      }
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.currentSga.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    testAlert(item) {
      this.sgaHiddenTalents.skillsKnowledgeOutsideWork.push(item);
      // (!this.sgaHiddenTalents.SkillsKnowledgeOutsideWork.includes(item)) {
      //this.sgaHiddenTalents.SkillsKnowledgeOutsideWork.push(item);
      // this.$notify({
      //   title: "Item added",
      //   position: "bottom-right",
      //   type: "success"
      // });
      //}
      //alert(item);
    }
  }
};
</script>

<style lang="scss">
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 1;
  transform: translateY(30px);
}
.el-notification {
  bottom: 80px !important;
}
.disclaimer {
  color: #a53131;
  font-size: 12px;
}
</style>
